<template>
  <div class="tree mim-common-seciton">
    <div
      class="bf-toolbar bf-toolbar bf-tree-toolbar"
      @click="open = !open"
      v-show="!open"
      title="目录树"
      style=""
    >
      <div class="bf-button gld-bf-tree" title="目录树"></div>
    </div>
    <el-dialog
      title="目录树"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
      v-dialogDrags
      :visible.sync="open"
    >
      <el-input
        class="searchbar"
        size="medium"
        placeholder="请输入关键词"
        prefix-icon="el-icon-search"
        v-model="filterText"
      >
      </el-input>

      <el-tree
        show-checkbox
        class="filter-tree mim-tree-select bf-panel-container bf-scroll-bar"
        :data="tree"
        @node-click="handleNodeClick"
        @check="getCheckedKeys"
        highlight-current
        node-key="ID"
        :props="defaultProps"
        :filter-node-method="filterNode"
        :default-expanded-keys="['-1']"
        :default-checked-keys="['-1']"
        :expand-on-click-node="false"
        ref="tree"
      >
        <template slot-scope="{ node, data }">
          <span class="custom-tree-node" :id="data.ID">
            <div
              class="bf-tree-icon"
              :class="[
                !data.transparent
                  ? 'gld-bf-untransparent'
                  : 'gld-bf-transparent',
              ]"
              title="半透明"
              @click.stop="handleTransparent(node, data)"
            ></div>
            {{ data.Name }}
          </span>
        </template>
      </el-tree>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import api from "@/url/mim.js";
export default {
  data() {
    return {
      tree: [],
      open: false,
      filterText: "",
      defaultProps: {
        children: "children",
        label: "Name",
      },
      curId: 0,
    };
  },
  props: {
    params: {
      type: Object,
      default: () => {},
    },
    xdata: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  methods: {
    // 给每个节点增加父节点
    addParents(arr, parentId = null) {
      return arr.map((item) => {
        const newObj = { ...item };
        //创建原始对象的副本，以避免直接修改原始对象
        if (parentId) {
          if (!newObj.parentIds) {
            newObj.parentIds = [];
          }
          newObj.parentIds.push(...parentId);
          // 将父节点ID添加到当前对象的parentIds数组中
        }
        if (newObj.children) {
          const curParentIds = newObj.parentIds || [];
          newObj.children = this.addParents(newObj.children, [
            ...curParentIds,
            newObj.ID,
          ]);
          // 递归处理子节点
        }
        return newObj;
      });
    },
    // 给每个节点增加子节点 const
    addDescendantIds(nodes, parentId = null) {
      nodes.forEach((node) => {
        node.descendantIds = [];
        // 初始化descendantIds属性
        if (parentId !== null) {
          node.descendantIds.push(node.ID);
          // 添加当前节点的ID
        }
        if (node.children && node.children.length > 0) {
          node.descendantIds = node.descendantIds.concat(
            this.addDescendantIds(node.children, node.ID)
          );
        }
      });
      return nodes.reduce((ids, node) => ids.concat(node.descendantIds), []);
      // 返回所有节点的ID
    },
    categoryTree(list) {
      if (!list) {
        return [];
      }
      const newList = this.addParents(list);
      this.addDescendantIds(newList);
      return newList;
    },
    /**获取树形列表 */
    getList() {
      const url = api.treeList;
      axios.get(url, { params: this.params }).then((res) => {
        if (res.data.code == 200) {
          // console.log("获取树形列表", res);
          // ID 为xdata 的key 名字
          const treeData = this.categoryTree(
            res.data.modelData.ProCategoryTree
          );
          // console.log("treeData", treeData);
          this.lookForAllId(treeData, false);
          this.tree = treeData;
        }
        this.$emit("list", {
          ...res.data.modelData,
          ProCategoryTree: this.tree,
        });
      });
    },
    /**过滤 */
    filterNode(value, data) {
      if (!value) return true;
      // const ids = Object.entries(this.xdata)
      //   .filter((e) => e[1] == value)
      //   .map((e) => Number(e[0]));
      //  增加模型id搜索
      // console.log("ids", ids, data, data.ID);
      return (
        String(data.Name).indexOf(value) != -1 ||
        String(data.ID).indexOf(value) != -1
      );
    },
    /**节点点击事件 */
    handleNodeClick(obj, node) {
      if (obj.ID == -1) {
        this.$refs.tree.setCurrentKey(this.curId == 0 ? null : this.curId);
        node.expanded = !node.expanded;
        return;
      }
      this.curId = obj.ID;
      this.$emit("handleSelectedComponents", obj);
    },
    /**选中节点 */
    handleSelectNode(curobj) {
      if (!this.open) {
        this.open = true;
      }
      this.$nextTick(() => {
        const curNode = this.$refs.tree.getNode(curobj.ID);
        if (!(this.$refs.tree && curNode)) {
          return;
        }
        // 选中当前选中节点
        this.$refs.tree && this.$refs.tree.setCurrentKey(curobj.ID);
        // 展开节点的父节点
        const parentIds = curobj.parentIds || [];
        parentIds.forEach((id) => {
          this.$refs.tree.store.nodesMap[id].expanded = true;
        });
        setTimeout(() => {
          // 滚动到指定位置
          const node = document.getElementById(curobj.ID);
          node && node.scrollIntoView({ block: "center" });
        }, 500);
      });
    },
    getCheckedKeys(node, { checkedKeys }) {
      if (node.ID == -1 && checkedKeys.length === 0) {
        this.$emit("hideAll");
      } else if (node.ID == -1 && checkedKeys.length) {
        this.$emit("showAll");
      } else if (checkedKeys.includes(node.ID)) {
        this.$emit("showSingle", node);
      } else if (!checkedKeys.includes(node.ID)) {
        this.$emit("hideSingle", node);
      }
    },
    // 递归修改所有子节点
    lookForAllId(data = [], transparent) {
      for (let item of data) {
        item.transparent = transparent;
        if (item.children && item.children.length)
          this.lookForAllId(item.children, transparent);
      }
    },
    findParent(node, transparent) {
      // transparent为空需要判断父节点是不是所有子节点都为空，不为空父节点都置为不为空
      if (transparent) {
        const children = node.data.children;
        let notChildren = [];
        if (children) {
          notChildren = children.filter((item) => !item.transparent);
        }
        if (!notChildren.length) {
          node.data.transparent = transparent;
        }
      } else {
        node.data.transparent = transparent;
      }
      if (node.parent) {
        this.findParent(node.parent, transparent);
      }
    },
    bindParentTransparent(node) {
      const { data } = node;
      const transparent = data.transparent;
      this.findParent(node.parent, transparent);
    },
    /**透明点击 */
    handleTransparent(node, data) {
      data.transparent = !data.transparent;
      // 子节点的transparent事件
      this.lookForAllId(data.children, data.transparent);
      // 父节点的transparent事件
      this.bindParentTransparent(node);
      // 操作构件，半透明事件
      if (data.ID == -1 && data.transparent) {
        this.$emit("transparentAll"); //所有构件半透明
      } else if (data.ID == -1 && !data.transparent) {
        this.$emit("untransparentAll"); //取消所有构件半透明
      } else if (!data.transparent) {
        this.$emit("untransparentSingle", data); //取消构件半透明
      } else if (data.transparent) {
        this.$emit("transparentSingle", data); //构件半透明
      }
    },
  },
  created() {},
  mounted() {},
  watch: {
    /**监听参数变化 */
    params(val) {
      const { location, file_id } = val;
      if (location && file_id) {
        this.getList();
      }
    },
    /**树形过滤方法 */
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>

<style>
@import "./tree.css";
</style>



// WEBPACK FOOTER //
// src/components/mim/tree.vue